/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:48
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2023-11-14 10:17:48
 * @FilePath: \frontend\src\Lang\index.js
 */
import enLocale from 'element-plus/es/locale/lang/en'; // lang i18n
import jaLocale from 'element-plus/es/locale/lang/ja'; // lang i18n
// import zhLocale from 'element-plus/es/locale/lang/zh-cn'; // lang i18n

import { createI18n } from 'vue-i18n';

import { I18n as AmplifyI18n } from 'aws-amplify/utils';
import { translations } from '@aws-amplify/ui-vue';
import { vocabularies } from './amplify_vocabularies.js';

/* ------------------------------------
*            导入语言包
------------------------------------*/

import ja_JP from './ja_JP.json'; // 导入包
import en_US from './en_US.json';
// import zh_CN from './zh_CN.json';

/* ------------------------------------
*            设置语言配置
------------------------------------*/
const DEFAULT_LANG = 'ja'; // 默认语言（当前使用的语言）
const LOCALE_KEY = 'local';

const locales = {
  ja: {
    ...jaLocale,
    ...ja_JP,
    ...vocabularies.ja,
  },
  en: {
    ...enLocale,
    ...en_US,
    ...vocabularies.en,
  },
  // zh: {
  //   ...zhLocale,
  //   ...zh_CN,
  // },
};

export const i18n = createI18n({
  legacy: true, // default: true
  locale: initLangSetup(), // 语言标识//this.$i18n.locale // 通过切换locale的值来实现语言切换,当 locale 的值为"zh-CN"时，版本为中文；当 locale 的值为"en-US",版本为英文。
  messages: locales,
});

AmplifyI18n.putVocabularies(translations);
AmplifyI18n.putVocabularies(vocabularies);
AmplifyI18n.setLanguage(initLangSetup());

/* ------------------------------------
*            设置语言配置
对外提供一个setup方法，用来修改我们的语言；
由于需要兼容多语言样式，所以这里在body上加入了相应的类名，方便我们做样式定制
------------------------------------*/
export const langSetup = (lang) => {
  if (lang === undefined) {
    lang = localStorage.getItem(LOCALE_KEY);
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG;
    }
  } else {
    localStorage.setItem(LOCALE_KEY, lang);
  }

  location.reload();
};

function initLangSetup() {
  let lang = localStorage.getItem(LOCALE_KEY);
  if (locales[lang] === undefined) {
    lang = DEFAULT_LANG;
  }

  return lang;
}
